import React, { useEffect, useRef, useState } from "react";

const Navigation = () => {
  const navbarRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <nav
      ref={navbarRef}
      className={`navbar navbar-expand-lg text-dark fixed-top ${
        scrolled ? "navbar-shadow" : ""
      }`}
    >
      <div className="container gx-0 d-flex align-items-center justify-content-between">
        <a className="navbar-brand text-dark" href="#">
          <img
            src="assets/images/logo.png"
            className="navbar-brand-logo"
            width="150px"
            alt=""
          />
        </a>

        {/* Mobile only */}
        <div className="d-lg-none d-md-block mx-auto no-border">
          <a
            href="https://app.fexila.com/login"
            style={{ marginRight: "15px" }}
          >
            <i className="bi bi-person" style={{ fontSize: "16px" }}></i>
            <span>Login</span>
          </a>
          <a
            href="https://app.fexila.com/register"
            className="btn btn-md btn-dark btn-outline-primary shadow"
            style={{ width: "130px" }}
          >
            Start free Trial
          </a>
        </div>

        <button
          className="navbar-toggler ms-auto ms-md-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="collapse navbar-collapse justify-content-center"
          id="navbarNav"
        >
          <ul className="navbar-nav mx-auto">
            <li className="nav-item">
              <a className="nav-link" href="#features">
                Features
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#pricing">
                Pricing
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#faqs">
                FAQs
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#contact">
                Contact
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="https://doc.fexila.com">
                <img
                  src="assets/images/book.png"
                  alt=""
                  style={{ display: "inline-block", marginRight: "5px" }}
                />{" "}
                Documentation
              </a>
            </li>
          </ul>
        </div>

        {/* Desktop only */}
        <div className="d-none d-lg-flex align-items-center">
          <a href="https://app.fexila.com/login">
            <i
              className="bi bi-person"
              style={{ fontSize: "16px", marginRight: "4px" }}
            ></i>
            <span>Login</span>
          </a>
          <div style={{ marginLeft: "20px" }}>
            <a
              href="https://app.fexila.com/register"
              className="btn btn-md btn-dark btn-outline-primary shadow"
              style={{ width: "130px" }}
            >
              Start free Trial
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
